import { CsvHeader, GroupCsvHeader } from 'src/app/file-download/interface/csvHeader';

export const CsvRowKeys: (keyof CsvHeader)[] = [
  'UniqueID',
  'LimitSetName',
  'RowType',
  'RuleType',
  'FilterName',
  'FilterValue',
  'Account',
  'TranslationLanguage',
  'TranslationValue',
  'Limits',
  'Units',
  'Compliancelevel',
  'Template'
];

export const groupCsvRowKeys: (keyof GroupCsvHeader)[] = [
  'UniqueID',
  'RowType',
  'RpCode',
  'RuleType',
  'Account',
  'TranslationLanguage',
  'TranslationValue'
];

export const groupCsvDisplayMap: Record<string, string> = {
  UniqueID: 'UniqueID',
  RowType: 'RowType',
  RpCode: 'RP Code',
  RuleType: 'RuleType',
  Account: 'Account',
  TranslationLanguage: 'TranslationLanguage',
  TranslationValue: 'TranslationValue'
};
